import React, { useState } from 'react';
import { Card, CardBody, CardHeader, Label } from 'reactstrap';
import './MapLegend.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faTimes } from '@fortawesome/free-solid-svg-icons';

export interface MapLegendProps {
    renderColorsDescription: () => JSX.Element[];
    renderShapesDescription?: () => React.JSX.Element[];
}

const MapLegend = (props: MapLegendProps) => {
    const [visible, setVisible] = useState(false);
    document
        .getElementById('map-legend')
        ?.addEventListener('click', function () {
            window.alert('Halo');
        });

    return (
        <div className="map-legend leaflet-bottom leaflet-right">
            <Card className="leaflet-control">
                <CardHeader>
                    <Label>{'Legend'}</Label>
                    <div
                        className="close-button"
                        onClick={() => {
                            setVisible(!visible);
                        }}>
                        {visible ? (
                            <FontAwesomeIcon icon={faTimes}></FontAwesomeIcon>
                        ) : (
                            <FontAwesomeIcon icon={faPlus}></FontAwesomeIcon>
                        )}
                    </div>
                </CardHeader>

                {visible ? (
                    <CardBody className="legend-body">
                        <div>{props.renderColorsDescription()}</div>
                        <div> {props.renderShapesDescription()}</div>
                    </CardBody>
                ) : (
                    <></>
                )}
            </Card>
        </div>
    );
};

export default MapLegend;
